import colors from '../../_shared/colors';

export default {
  filtersContainer: `
    border-bottom: 2px solid ${colors.inputBorder};
    height: auto;
  `,
  pbFiltersContainer: `
    /* sit just below the sticky search bar so the filters / Clear remain
       visible when the user scrolls the equipment list. */
    position: sticky;
    top: 72px;
    z-index: 15;
    background-color: ${colors.white};
    margin-left: -20px;
    margin-right: -20px;
    padding: 8px 20px 12px 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  `,
  container: `
    height: auto;
    width: calc(100% + 40px);
    margin-left: -20px;
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;
  `,
  pbContainer: `
    height: 60px;
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-top: -20px;
    padding-left: 20px;
    padding-right: 20px;
  `,
  pbSearch: `
    margin-bottom: 20px;

    .ant-input-search {
      width: 100% !important;
    }
  `,
  margRight: `
    margin-right: 5px;
  `,
  select: `
    width: 150px;
  `,
  link: `
    font-size: 16px;
    margin-left: 10px;
    margin-right: 10px;
  `,
  viewContainer: `
    margin-left: auto;
  `,
  viewIcon: `
    margin-right: 10px;
    cursor: pointer;
    &: hover {
      opacity: 0.8;
    }
  `,
  pbFilters: `
    width: 100%;

    .ant-select, > .ant-btn {
      width: 100% !important;
      margin-bottom: 10px;
    }
  `,
};
